import React from 'react'
import PropTypes from 'prop-types'
import {
    Carousel,
    CarouselContent,
    CarouselItem,
    CarouselNext,
    CarouselPrevious,
    ContentButtonNavigation
} from '@/components/ui/carousel'
import ModuleCard from './moduleCard'
import {Heading} from '@/components/ui/heading'
import useMediaQuery from 'hec/hooks/useMediaQuery'

const Level = ({levelData, goalID}) => {
    const {levelID, levelNumber, title, modules, started} = levelData
    const modulesLength = modules.length
    const isMobile = useMediaQuery('lg')
    const slidesVisibleDekstop = 4
    const slidesVisibleMobile = 1
    const showUIControls = modulesLength > (isMobile ? slidesVisibleMobile : slidesVisibleDekstop) // TO DO: replace 10 with modulesLength

    return (
        <div>
            <Heading
                tag="h3"
                variant="h3"
                className="text-center md:text-left lg:text-left"
                data-testid="level-Heading"
            >
                Level {levelNumber}: {title}
            </Heading>
            <Carousel opts={{loop: true}} data-testid="level-Carousel">
                {showUIControls && (
                    <CarouselPrevious overlapContent={true} data-testid="level-CarouselPrevious" />
                )}
                <CarouselContent className="mt-4 mx-0 lg:-mx-3" data-testid="level-CarouselContent">
                    {modules.map((module, moduleIndex) => (
                        <CarouselItem
                            key={moduleIndex}
                            slidesVisible={slidesVisibleDekstop}
                            slidesVisibleMobile={slidesVisibleMobile}
                            slidePadding={3}
                            slidePaddingMobile={0}
                            data-testid="level-CarouselItem"
                        >
                            <div className="flex justify-center h-full">
                                <div className="w-[17.9375rem] lg:w-full h-full">
                                    <ModuleCard
                                        moduleData={module}
                                        levelID={levelID}
                                        levelStarted={started}
                                        goalID={goalID}
                                        data-testid="level-ModuleCard"
                                    />
                                </div>
                            </div>
                        </CarouselItem>
                    ))}
                </CarouselContent>
                {showUIControls && (
                    <CarouselNext overlapContent={true} data-testid="level-CarouselNext" />
                )}
                {showUIControls && (
                    <ContentButtonNavigation
                        buttonType="flatButton"
                        data-testid="level-ContentButtonNavigation"
                    />
                )}
            </Carousel>
        </div>
    )
}

Level.propTypes = {
    levelData: PropTypes.shape({
        levelID: PropTypes.string.isRequired,
        levelNumber: PropTypes.number.isRequired,
        title: PropTypes.string.isRequired,
        modules: PropTypes.array.isRequired,
        started: PropTypes.bool.isRequired
    }).isRequired,
    goalID: PropTypes.string.isRequired
}

export default Level
